import type { CountryCode } from '@hotjar/country-lib';
import { isCountryCode } from '@hotjar/country-lib';
import { undelimit } from '../queryUtils';

export function parseCountryList(value: string): CountryCode[] {
  const values = undelimit(value);
  const countries = new Set<string>(values);
  return Array.from(countries).filter(isCountryCode).sort();
}
